<!-- Header -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">swap_vert</mat-icon>
    <h2 style="margin: 0; font-size: 1.15rem; font-weight: 700; color: #1e5a3f;">Asignación Puntos Spot</h2>
  </div>
  <button type="button" (click)="dialogRef.close(false)"
    style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
    onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
  </button>
</div>

<!-- Body -->
<div style="padding: 24px;">
  <!-- Selected users badge -->
  <div *ngIf="data.length > 0" style="display: flex; align-items: center; gap: 8px; margin-bottom: 20px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">group</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">{{ data.length }} usuario(s) seleccionado(s)</span>
  </div>

  <mat-form-field appearance="outline" class="modern-field w-full">
    <mat-label>Puntos spot</mat-label>
    <input matInput appOnlynumber type="number" step="0.1" placeholder="Ej: 0.1" name="spotPoints" [(ngModel)]="spotPoints">
  </mat-form-field>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap;">
  <button type="button" (click)="dialogRef.close(false)"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <button type="button" (click)="editSegmentation()"
    style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
    Asignar
  </button>
</div>
